<template>
  <div class="widgets">
    <div class="widgets--wrapper">
      <div
        v-for="(widget, index) in defaultWidgets"
        :key="index"
        :class="
          getWidgetVisibility
            ? 'widgets__content-orders-search'
            : 'widgets__content'
        "
      >
        <widget-renderer :widgetToRender="widget.name" :size="widget.size" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    'widget-renderer': () => import('./WidgetRenderer.vue')
  },
  computed: {
    ...mapGetters('generalIndicators', ['visibleIndicators']),
    ...mapGetters('orders', ['getWidgetVisibility']),
    ...mapGetters(['isBilling']),
    ...mapState(['currentEntity']),

    defaultWidgets() {
      return this.getWidgetVisibility
        ? this.ordersSearchPermission
        : this.noOrdersSearchPermission
    },

    noOrdersSearchPermission() {
      return [
        { name: 'notifications-widget', size: 3 },
        this.visibleIndicators
          ? { name: 'orders-widget', size: 3 }
          : { name: 'content-left', size: 3 },
        { name: 'research-widget', size: 1 },
        this.isBilling
          ? { name: 'billing-widget', size: 1 }
          : { name: 'empty-widget', size: 1 }
      ]
    },

    ordersSearchPermission() {
      return [
        { name: 'notifications-widget', size: 3 },
        this.visibleIndicators
          ? { name: 'orders-widget', size: 3 }
          : { name: 'content-left', size: 3 },
        { name: 'search-orders-widget', size: 1 },
        { name: 'research-widget', size: 1 },
        this.isBilling
          ? { name: 'billing-widget', size: 1 }
          : { name: 'empty-widget', size: 1 }
      ]
    }
  },
  methods: {
    ...mapMutations('generalIndicators', ['TOGLE_VISIBLE_INDICATORS']),
    ...mapActions('orders', ['getSearchOrdersValidation']),

    searchOrdersValidation() {
      this.getSearchOrdersValidation(this.currentEntity.entityLegacyId)
    }
  },
  watch: {
    currentEntity(newEntity) {
      if (newEntity) {
        this.TOGLE_VISIBLE_INDICATORS(true)
      }
      this.searchOrdersValidation()
    }
  },
  mounted() {
    this.searchOrdersValidation()
  }
}
</script>

<style lang="scss" scoped>
.widgets {
  &--wrapper {
    display: grid;
    margin: auto;
    grid-template-rows: repeat(3, 1fr);
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: column;
    gap: 16px;
    height: 85vh;
    align-items: stretch;
    max-width: calc(588px * 3 + 42px - 5rem);

    @media (max-width: $bp-xg) {
      margin: unset;
    }

    @media (max-width: $bp-md) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(5, 1fr);
      grid-auto-flow: row;
      height: unset;
    }

    @media (max-height: $bp-sm) {
      height: unset;
    }
  }
  &__content,
  &__content-orders-search {
    display: grid;
  }
  &__content-orders-search:first-child,
  &__content:first-child {
    grid-area: 1 / 1 / 4 / 2;

    @media (max-width: $bp-md) {
      grid-area: 1 / 2 / 4 / 3;
    }
  }
  &__content-orders-search:nth-child(2) {
    grid-area: 1 / 2 / 4 / 3;

    @media (max-width: $bp-md) {
      grid-area: 1 / 1 / 3 / 2;
    }
  }
  &__content:nth-child(2) {
    grid-area: 1 / 2 / 4 / 3;

    @media (max-width: $bp-md) {
      grid-area: 1 / 1 / 3 / 2;
    }
  }
}
</style>
